/**
 * Width Sapcer
 */
export const WSpacer = ({ width }) => (
  <div style={{ width: `${width ? width : '0%'}`, height: '100%' }}></div>
)

/**
 * Height Sapcer
 */
export const HSpacer = ({ height }) => (
  <div style={{ width: '100%', height: `${height ? height : '0%'}` }}></div>
)
